"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ImmutablePrioritySet_1 = require("../util/ImmutablePrioritySet");
const Accidental_1 = require("./Accidental");
const Key_1 = require("./Key");
const Letter_1 = require("./Letter");
var Policy;
(function (Policy) {
    function prioritize(...policies) {
        return ImmutablePrioritySet_1.default.of(policies);
    }
    Policy.prioritize = prioritize;
    function matchLetter(letter) {
        return k => k.getLetter() === letter;
    }
    Policy.matchLetter = matchLetter;
    function matchAccidental(accidental) {
        return k => k.getAccidental().orElse(null) === accidental;
    }
    Policy.matchAccidental = matchAccidental;
    function matchKeySignature(keySignature) {
        const keys = Letter_1.default
            .values()
            .map(l => new Key_1.default(l))
            .map(k => k.apply(keySignature));
        return k => keys[k.getLetter().ordinal()].equals(k);
    }
    Policy.matchKeySignature = matchKeySignature;
    Policy.NONE = matchAccidental(null);
    Policy.NATURAL = matchAccidental(Accidental_1.default.NATURAL);
    Policy.NONE_OR_NATURAL = k => Policy.NONE(k) || Policy.NATURAL(k);
    Policy.SHARP = matchAccidental(Accidental_1.default.SHARP);
    Policy.DOUBLE_SHARP = matchAccidental(Accidental_1.default.DOUBLE_SHARP);
    Policy.TRIPLE_SHARP = matchAccidental(Accidental_1.default.TRIPLE_SHARP);
    Policy.SHARPS = k => Policy.SHARP(k) || Policy.DOUBLE_SHARP(k) || Policy.TRIPLE_SHARP(k);
    Policy.FLAT = matchAccidental(Accidental_1.default.FLAT);
    Policy.DOUBLE_FLAT = matchAccidental(Accidental_1.default.DOUBLE_FLAT);
    Policy.TRIPLE_FLAT = matchAccidental(Accidental_1.default.TRIPLE_FLAT);
    Policy.FLATS = k => Policy.FLAT(k) || Policy.DOUBLE_FLAT(k) || Policy.TRIPLE_FLAT(k);
    Policy.DEFAULT_PRIORITY = prioritize(Policy.NONE_OR_NATURAL, Policy.SHARP, Policy.FLAT);
})(Policy || (Policy = {}));
exports.default = Policy;
